import store from '@/app/store/index'

const predefinedColors = [
  "#26BD7E",
  "#006b68",
  "#47bbea",
  "#0067b1",
  "#c9a471",
  "#51af71",
  "#e8757f",
  "#fff367",
  "#650e81",
  "#a56800",
  "#740047",
  "#e47508",
  "#4e6b06",
  "#363026",
  "#7d7d7d",
  "#34004a",
  "#8d8100",
  "#dd0053",
  "#8fd324",
  "#4e6b06"
];

const coresIndexadores = [
  { nome: "CDI", cor: "#FFAB00" },
  { nome: "Ibovespa", cor: "#2D90D9" },
  { nome: "Dolar Comercial", cor: "#006644" },
  { nome: "IBOVESPA", cor: "#2D90D9" },
  { nome: "IPCA", cor: "#859F3F" },
  { nome: "IGPM", cor: "#FF7452" },
  { nome: "Poupanca", cor: "#413294" },
  { nome: "Carteira", cor: "#26BD7E" }
];

const coresTreemaps = {
  negativo: [
    { cor: "#ffdada", font: "#ee0000" },
    { cor: "#f5b3b3", font: "#ee0000" },
    { cor: "#ec8282", font: "#FFFFFF" },
    { cor: "#ea5d5d", font: "#FFFFFF" },
    { cor: "#eb3535", font: "#FFFFFF" },
    { cor: "#ee0000", font: "#FFFFFF" }
  ],
  positivo: [
    { cor: "#c1f0c2", font: "#0ac20e" },
    { cor: "#9fe7a0", font: "#0ac20e" },
    { cor: "#79e07b", font: "#FFFFFF" },
    { cor: "#5edb60", font: "#FFFFFF" },
    { cor: "#2cd22f", font: "#FFFFFF" },
    { cor: "#0ac20e", font: "#FFFFFF" },
  ]
};

function cutHex(h) {
  return h.charAt(0) == "#" ? h.substring(1, 7) : h;
}

function getLowestMiddleHighest(rgbIntArray) {
  let highest = { val: 0, index: -1 };
  let lowest = { val: Infinity, index: -1 };

  rgbIntArray.map((val, index) => {
    if (val > highest.val) {
      highest = { val: val, index: index };
    }
    if (val < lowest.val) {
      lowest = { val: val, index: index };
    }
  });

  let middle = { index: 3 - highest.index - lowest.index };
  middle.val = rgbIntArray[middle.index];
  return [lowest, middle, highest];
}

function getLightnessOfRGB(rgbString) {
  // First convert to an array of integers by removing the whitespace, taking the 3rd char to the 2nd last then splitting by ','
  const rgbIntArray = rgbString
    .replace(/ /g, "")
    .slice(4, -1)
    .split(",")
    .map((e) => parseInt(e));

  // Get the highest and lowest out of red green and blue
  const highest = Math.max(...rgbIntArray);
  const lowest = Math.min(...rgbIntArray);
  // Return the average divided by 255
  return (highest + lowest) / 2 / 255;
}

// Eu nem tentei entender o que isso faz
// https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
// Version 4.0
const pSBC = function(p, c0, c1, l) {
  let r,
    g,
    b,
    P,
    f,
    t,
    h,
    i = parseInt,
    m = Math.round,
    a = typeof c1 == "string";
  if (
    typeof p != "number" ||
    p < -1 ||
    p > 1 ||
    typeof c0 != "string" ||
    (c0[0] != "r" && c0[0] != "#") ||
    (c1 && !a)
  )
    return null;
  var pSBCr = d => {
    let n = d.length,
      x = {};
    if (n > 9) {
      ([r, g, b, a] = d = d.split(",")), (n = d.length);
      if (n < 3 || n > 4) return null;
      (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
        (x.g = i(g)),
        (x.b = i(b)),
        (x.a = a ? parseFloat(a) : -1);
    } else {
      if (n == 8 || n == 6 || n < 4) return null;
      if (n < 6)
        d =
          "#" +
          d[1] +
          d[1] +
          d[2] +
          d[2] +
          d[3] +
          d[3] +
          (n > 4 ? d[4] + d[4] : "");
      d = i(d.slice(1), 16);
      if (n == 9 || n == 5)
        (x.r = (d >> 24) & 255),
          (x.g = (d >> 16) & 255),
          (x.b = (d >> 8) & 255),
          (x.a = m((d & 255) / 0.255) / 1000);
      else (x.r = d >> 16), (x.g = (d >> 8) & 255), (x.b = d & 255), (x.a = -1);
    }
    return x;
  };
  (h = c0.length > 9),
    (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
    (f = pSBCr(c0)),
    (P = p < 0),
    (t =
      c1 && c1 != "c"
        ? pSBCr(c1)
        : P
        ? { r: 0, g: 0, b: 0, a: -1 }
        : { r: 255, g: 255, b: 255, a: -1 }),
    (p = P ? p * -1 : p),
    (P = 1 - p);
  if (!f || !t) return null;
  if (l)
    (r = m(P * f.r + p * t.r)),
      (g = m(P * f.g + p * t.g)),
      (b = m(P * f.b + p * t.b));
  else
    (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
      (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
      (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
  (a = f.a),
    (t = t.a),
    (f = a >= 0 || t >= 0),
    (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
  if (h)
    return (
      "rgb" +
      (f ? "a(" : "(") +
      r +
      "," +
      g +
      "," +
      b +
      (f ? "," + m(a * 1000) / 1000 : "") +
      ")"
    );
  else
    return (
      "#" +
      (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0))
        .toString(16)
        .slice(1, f ? undefined : -2)
    );
};

const ColorsService = {
  getRandomColour(seed) {
    if (typeof seed !== "undefined") {
      if (isNaN(seed)) {
        let index = 0;
        let avgAsciiSeed = 0;

        for (var i = 0; i < seed.length; i++) {
          avgAsciiSeed += seed.charCodeAt(i);
        }

        avgAsciiSeed = avgAsciiSeed / seed.length;

        for (var j = 0; j < avgAsciiSeed; j++) {
          index++;

          if (index > predefinedColors.length) {
            index = 0;
          }
        }

        let cor = undefined;
        let indx = 0;
        while (cor === undefined) {
          cor = predefinedColors[index - indx]
          indx++;
        }

        return cor;
      } else if (seed <= predefinedColors.length) {
        let cor = undefined;
        let indx = 0;
        while (cor === undefined) {
          cor = predefinedColors[seed - indx]
          indx++;
        }
        return cor;
      }
    }

    var rgn = Math.floor(Math.random() * predefinedColors.length) - 1;
    return predefinedColors[rgn];
  },

  getIndexadorColor(nomeIndexador) {
    return coresIndexadores.find(cor => cor.nome.toLowerCase() == nomeIndexador.toLowerCase())?.cor || this.getRandomColour(nomeIndexador)
  },

  getLigherVersion(color, intensity) {
    if (!intensity)
      return pSBC(0.2, color);
    else
      return pSBC(intensity * 0.8, color);
  },

  getDarkerVersion(color, intensity) {
    if (!intensity)
      return pSBC(-0.2, color);
    else
      return pSBC(intensity * -1 * 0.08, color);
  },

  getFixedColors(qtd, skip) {
    let colors = [];

    if (skip && !isNaN(skip)) {
      for (let i = skip; i < qtd + skip; i++) {
        colors.push(predefinedColors[i]);
      }
    } else {
      for (let i = 0; i < qtd; i++) {
        colors.push(predefinedColors[i]);
      }
    }

    return colors;
  },

  addSaturation(color, amount) {
    color = color.replace('#', '').split('');
    var letters = '0123456789ABCDEF'.split('');
    for (var i = 0; i < color.length; i++){
      var newSaturation = 0;
      if (letters.indexOf(color[i]) + amount > 15) newSaturation = 15;
      else if (letters.indexOf(color[i]) + amount < 0) newSaturation = 0;
      else newSaturation = letters.indexOf(color[i]) + amount;
      color[i] = letters[newSaturation];
    }
    return "#" + color.join('');
  },

  getBlackWhiteVersion(color) {
    const rgb = this.hexToRgb(color)
    const rgbIntArray = rgb
      .replace(/ /g, "")
      .slice(4, -1)
      .split(",")
      .map((e) => parseInt(e))
    const [lowest, middle, highest] = getLowestMiddleHighest(rgbIntArray)
    const greyVal = getLightnessOfRGB(rgb) * 255

    //if colour is just grey, return grey
    if (lowest.val === highest.val) {
      return color
    }

    const amountOfDesaturation = 1; // percentage (lower = darker)

    const saturationRange = Math.round(Math.min(255 - greyVal, greyVal));
    const maxChange = greyVal - lowest.val;
    const changeAmount = Math.min(saturationRange / amountOfDesaturation, maxChange);

    const middleValueRatio = (greyVal - middle.val) / (greyVal - highest.val);

    const returnArray = [];
    returnArray[highest.index] = Math.round(highest.val - changeAmount);
    returnArray[lowest.index] = Math.round(lowest.val + changeAmount);
    returnArray[middle.index] = Math.round(
      greyVal + (returnArray[highest.index] - greyVal) * middleValueRatio
    );
    return `rgb(${[returnArray].join()})`;
  },

  hexToRgb(h) {
    var r = parseInt(cutHex(h).substring(0, 2), 16)
    var g = parseInt(cutHex(h).substring(2, 4), 16)
    var b = parseInt(cutHex(h).substring(4, 6), 16)
    return "rgb(" + r + "," + g + "," + b + ")"
  },

  getRandomColors(qtd) {
		let colors = []
		let allColors = predefinedColors
		let quantidadeRestante = qtd

		//@Christian: loop para caso o qtd seja maior que o total de cores predefinidas, ele repete as predefinidas o quanto for nescessário
		while (quantidadeRestante >= allColors.length) {
			colors = colors.concat(allColors)
			quantidadeRestante -= allColors.length
		}

		//@Christian: loop para aleatorizar as cores usando um array auxiliar (allColors) para evitar repetição de cores e evitar o "O(∞)" como a antiga versão dessa função
		while (quantidadeRestante > 0) {
			let color = allColors[Math.floor(Math.random() * allColors.length)]
			allColors = allColors.filter(item => item !== color)

			colors.push(color)
			quantidadeRestante--
		}
		return colors
	},
  getPredefinedColors(qtd) {
		let colors = []
		let allColors = predefinedColors
		let quantidadeRestante = qtd

		//@Christian: loop para caso o qtd seja maior que o total de cores predefinidas, ele repete as predefinidas o quanto for nescessário
		while (quantidadeRestante >= allColors.length) {
			colors = colors.concat(allColors)
			quantidadeRestante -= allColors.length
		}

		if (quantidadeRestante > 0) {
			colors = colors.concat(allColors.slice(0, quantidadeRestante))
		}

		return colors
	},

  getTreemapColors() {
    return coresTreemaps;
  },

  getEstrategiaColor(nome) {
    let estrategiaAtivosColors = store.getters.usuario.estrategiaColors || []
    return estrategiaAtivosColors.find(cor => cor.key == nome)?.value || this.getRandomColour(nome)
  },
  getCssColorValue(name) {
    let root = document.querySelector(':root')
    return root.style.getPropertyValue(`--${name}`)
  },
}

export default ColorsService
